"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaAnalyticsStorage = void 0;
var browser_storage_item_1 = require("./browser-storage-item");
var json_storage_item_1 = require("./json-storage-item");
var AlgoliaAnalyticsStorage = (function () {
    function AlgoliaAnalyticsStorage() {
        this.key = 'algoliaAnalytics';
        this.storage = new json_storage_item_1.JsonStorageItem(new browser_storage_item_1.BrowserStorageItem(this.key, browser_storage_item_1.StorageType.LOCAL_STORAGE));
    }
    AlgoliaAnalyticsStorage.prototype.get = function () {
        return this.storage.get() || {};
    };
    AlgoliaAnalyticsStorage.prototype.add = function (objectId, source, _a) {
        var _b, _c;
        var _d = _a.timestamp, timestamp = _d === void 0 ? Date.now() : _d, other = __rest(_a, ["timestamp"]);
        var algoliaAnalytics = this.get();
        this.storage.set(__assign(__assign({}, algoliaAnalytics), (_b = {}, _b[objectId] = __assign(__assign({}, (algoliaAnalytics[objectId] || {})), (_c = {}, _c[source] = __assign(__assign({}, other), { timestamp: timestamp }), _c)), _b)));
    };
    AlgoliaAnalyticsStorage.prototype.getAnalyticsObject = function (objectId) {
        return this.get()[objectId];
    };
    AlgoliaAnalyticsStorage.prototype.getAnalyticsDataBySource = function (objectId, source) {
        var _a;
        return (_a = this.getAnalyticsObject(objectId)) === null || _a === void 0 ? void 0 : _a[source];
    };
    AlgoliaAnalyticsStorage.prototype.removeAnalyticsObject = function (objectId, algoliaAnalytics) {
        var algoliaAnalyticsData = algoliaAnalytics || this.get();
        if (algoliaAnalyticsData[objectId])
            delete algoliaAnalyticsData[objectId];
        if (!Object.keys(algoliaAnalyticsData).length) {
            this.clear();
            return;
        }
        this.storage.set(algoliaAnalyticsData);
    };
    AlgoliaAnalyticsStorage.prototype.removeAnalyticsDataBySource = function (objectId, source) {
        var algoliaAnalyticsData = this.get();
        if (algoliaAnalyticsData[objectId]) {
            delete algoliaAnalyticsData[objectId][source];
            if (!Object.keys(algoliaAnalyticsData[objectId]).length) {
                this.removeAnalyticsObject(objectId, algoliaAnalyticsData);
                return;
            }
        }
        this.storage.set(algoliaAnalyticsData);
    };
    AlgoliaAnalyticsStorage.prototype.clear = function () {
        this.storage.remove();
    };
    return AlgoliaAnalyticsStorage;
}());
exports.AlgoliaAnalyticsStorage = AlgoliaAnalyticsStorage;
//# sourceMappingURL=algolia-analytics-storage.js.map